import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-9 col-lg-8 col-md-7" }
const _hoisted_3 = { class: "col-xxl-3 col-lg-4 col-md-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionsHistory = _resolveComponent("TransactionsHistory")!
  const _component_UserCard = _resolveComponent("UserCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TransactionsHistory)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_UserCard)
    ])
  ]))
}